import { bl_alg_cc_login_subject_link_RowClass } from "../../../../dbschema";
import {BaseContainerModel} from "../../../base-container.model";

export class LoginSubjectLinkContainerModel extends BaseContainerModel {
  bl_alg_cc_login_subject_link: bl_alg_cc_login_subject_link_RowClass = new bl_alg_cc_login_subject_link_RowClass();
}
